export default __webpack_public_path__ + "static/media/Logo_Ponts.0b6885b8.png";